import axios from "axios";
import apiUrlOne from "../../utils.js/Config";
import { adminUserLogout } from "../AdminUsers/AdminUsersApis";

const authApi = axios.create({
    baseURL: apiUrlOne,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const login = async (email, password) => {
    try {
        const response = await authApi.post('/admin-users/login', { email, password });
        const { data } = response.data;

        // Save access token to localStorage if login successful
        if (response.data && response.data.success && data && data.accessToken) {
            localStorage.setItem('accessToken', data.accessToken);
            // Optionally save user info if provided
            if (data.user) {
                localStorage.setItem('user', JSON.stringify(data.user));
            }
        }

        return response.data;
    } catch (error) {
        throw error;
    }
};

// Logout function to clear stored authentication data
export const logout = async () => {
    try {
        await adminUserLogout(); // call backend logout
    } catch (error) {
        console.error("Logout API failed, clearing local storage anyway");
    }

    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
};

// Forgot Password API - Step 1: Send OTP to email
export const forgotPassword = async (email) => {
    try {
        const response = await authApi.post('/admin-users/forgot-password', { email });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Reset Password API - Step 2: Reset password using token, OTP and new password
export const resetPassword = async (resetToken, otp, newPassword) => {
    try {
        const response = await authApi.post('/admin-users/reset-password', {
            resetToken,
            otp,
            newPassword
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default authApi;